import Network from '@/services/network'
import {ref} from "vue";

export default function handleHospital() {
    const network = new Network;
    const chartLoading = ref(false)

    // date of barth convert to age
    const dateOfBarthConvertToAge = (birthday, currentDate = '') => {
        const birthDate = new Date(birthday + "T00:00:00");
        let today = new Date();
        if (currentDate) {
            today = new Date(currentDate);
        }

        let year= today.getFullYear() - birthDate.getFullYear();
        let month= today.getMonth() - birthDate.getMonth();
        let day= today.getDate() - birthDate.getDate();

        if (day < 0) {
            month--;
            const borrowMonth = new Date(
                birthDate.getFullYear() + year,
                birthDate.getMonth() + 1,
                0
            ).getDate();
            day += borrowMonth;
        }

        if (month < 0) {
            year--;
            month += 12;
        }

        return { year, month, day };
    }

    // convert age to Y, M, D
    const calculateAge = (birthday, currentDate = '') => {
        var date = '';
        const {year, month, day} = dateOfBarthConvertToAge(birthday, currentDate)

        if(year) {
            date += `${year}Y `;
        }
        if(month) {
            date += `${month}M `;
        }
        if(day) {
            date += `${day}D`;
        }

        return date
    }

    const capitalize = (text) => {
        if(!text || typeof text !== 'string') {
            return text;
        }

        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    const convertHeightToFeetAndInches = (heightInCm) => {
        const totalInches = Math.round(heightInCm / 2.54);
        const feet = Math.floor(totalInches / 12);
        const inches = totalInches % 12;
    
        return { feet, inches };
    }

    const convertFeetAndInchesToCm = (feet, inches) => {
        return (((parseFloat(feet) || 0) * 12) + (parseFloat(inches) || 0)) * 2.54;
    }

    const bmiCalculator = (heightInCm, weightInKg) => {
        return heightInCm > 0 && weightInKg > 0 && ((weightInKg * 10000) / (heightInCm * heightInCm)).toFixed(2);
    }

    //Service Resources Group
    const fetchGroup = (companyId, resourceType) => {
        return network.api('get', 'hospital/service-resources/groups?company_id=' + companyId + '&is_flatten=1&resource_type=' + resourceType);
    }
    const storeGroup = (data) => {
        return network.api('post', '/hospital/service-resources/groups', data);
    }
    const updateGroup = (data) => {
        return network.api('put', '/hospital/service-resources/groups/' + data.id, data);
    }

    // Service Resource
    const fetchServiceResourceList = (query) => {
        return network.api('get', '/hospital/service-resources/list' + query);
    }
    const fetchServiceList = (query, type) => {
        if(type){
            query += `&resource_type=${type}`;
        }
        return network.api('get', '/hospital/service-resources/get-services' + query);
    }
    const fetchServiceResources = (query) => {
        return network.api('get', '/hospital/service-resources' + query);
    }

    const fetchServiceResourceListView = (query) => {
        return network.api('get', '/hospital/service-resources/list-view' + query);
    }

    const fetchServiceResourceChild = (groupId, query) => {
        return network.api('get', `/hospital/service-resources/child/${groupId}` + query);
    }
    const storeServiceResource = (data) => {
        return network.api('post', '/hospital/service-resources', data);
    }
    const updateServiceResource = (data) => {
        return network.api('put', '/hospital/service-resources/' + data.id, data);
    }

    //Patient
    const fetchPatientsList = (query) => {
        return network.api('get', '/hospital/patients/list' + query);
    }
    const fetchPatientDetails = (query, id) => {
        return network.api('get', '/hospital/patients/details/' + id + query);
    }
    const fetchPatientDetailsBySerial = (query, id) => {
        return network.api('get', '/hospital/patients/details-by-serial/' + id + query);
    }

    //Note
    const fetchNoteTypes = (query) => {
        return network.api('get', '/hospital/note-masters/types' + query);
    }
    const fetchNoteMasterList = (query) => {
        return network.api('get', '/hospital/note-masters' + query);
    }
    const storeNote = (data) => {
        return network.api('post', '/hospital/note-masters', data);
    }
    const updateNote = (data) => {
        return network.api('put', '/hospital/note-masters/' + data.id, data);
    }
    const removeNote = (query, id) => {
        return network.api('delete', '/hospital/note-masters/' + id + query);
    }
    const notesByType = (query, type) => {
        return network.api('get', '/hospital/note-masters/notes-by-type/' + type + query);
    }
    const fetchPrescriptionNotes = (query) => {
        return network.api('get', '/hospital/note-masters/prescription-notes' + query);
    }
    const fetchGroupTemplateTabs = (query) => {
        return network.api('get', '/hospital/note-masters/group-template-tabs' + query);
    }
    const noteNameByType = (query) => {
        return network.api('get', '/hospital/note-masters/note-name-by-type' + query);
    }
    const fetchNoteByKey = (query, type, note_key) => {
        return network.api('get', `/hospital/note-masters/by-key/${type}/${note_key}` + query);
    }

    //IPD-Regsiter 
    const fetchIPDRegistrationList = (query) => {
        return network.api('get', '/hospital/ipd-registers' + query);
    }
    const storeRegistration = (data) => {
        return network.api('post', '/hospital/ipd-registers', data);
    }
    const updateRegistration = (data, id) => {
        return network.api('put', '/hospital/ipd-registers/' + id, data);
    }
    const fetchAdmittedByUserList = (query, type = 'patient') => {
        query += `&type=${type}`;
        return network.api('get', '/hospital/ipd-registers/contact-profile-user' + query);
    }
    const fetchDepartList = (query) => {
        return network.api('get', '/hospital/ipd-registers/department-list' + query);
    }
    const fetchAdmissionNoteList = (query) => {
        return network.api('get', '/hospital/ipd-registers/admission-notes' + query);
    }
    const fetchSingleNote = (query, id) => {
        return network.api('get', '/hospital/ipd-registers/' + id + query);
    }
    const fetchIpdRegStatus = (query) => {
        return network.api('get', '/hospital/ipd-registers/ipd-registration-status' + query);
    }
    const fetchIpdRegNumbers = (query) => {
        return network.api('get', '/hospital/ipd-registers/ipd-admission-numbers' + query);
    }
    const fetchIpdStatement = (query) => {
        return network.api('get', '/hospital/report/ipd-statement' + query);
    }

    //Prescription
    const fetchSinglePrescription = (query, id, prescriptionType) => {
        return network.api('get', `/hospital/prescriptions/show-prescription/${id}/${prescriptionType}` + query);
    }
    const storePrescription = (data) => {
        return network.api('post', '/hospital/prescriptions/store-prescription', data);
    }
    const updatePrescription = (data, id) => {
        return network.api('put', '/hospital/prescriptions/update-prescription/' + id, data);
    }
    const fetchIpdStatementDetails = (id, productId, query) => {
        return network.api('get', `/hospital/report/ipd-statement-details/${id}/product/${productId}` + query)
    }
    const fetchIpdStatementDetailsMulti = (id, query) => {
        return network.api('get', `/hospital/report/ipd-statement-details/${id}/multi-product` + query)
    }
    const fetchTemplatePrescription = (query, doctorOrderId) => {
        return network.api('get', `/hospital/prescriptions/template-prescription/${doctorOrderId}` + query);
    }
    const fetchOpdPrescriptionReport = (query) => {
        return network.api('get', `/hospital/prescriptions/opd-prescription-report` + query);
    }

    //Doctor-order
    const fetchSingleDoctorOrder = (query, id, prescriptionType) => {
        return network.api('get', `/hospital/doctor-orders/show-general-order/${id}/${prescriptionType}`+ query);
    }
    const fetchSingleDischargeOrder = (query, id, prescriptionType) => {
        return network.api('get', `/hospital/doctor-orders/show-discharge-order/${id}/${prescriptionType}`+ query);
    }

    //Ot-orders 
    const fetchOtOrderTypes = (query) => {
        return network.api('get', '/hospital/ot-orders/ot-types' + query);
    }
    const storeOtOrder = (data) => {
        return network.api('post', '/hospital/ot-orders/store-ot-order', data);
    }
    const updateOtOrder = (data, id) => {
        return network.api('put', '/hospital/ot-orders/update-ot-order/' + id, data);
    }
    const fetchOtOrderList = (query) => {
        return network.api('get', '/hospital/ot-orders/list' + query);
    }
    const removeOtOrder = (query, id) => {
        return network.api('delete', '/hospital/ot-orders/destroy/' + id + query);
    }
    const fetchSingleOtOrder = (query, id) => {
        return network.api('get', '/hospital/ot-orders/show/' + id + query);
    }

    //Baby notes 
    const fetchInitialBabyNoteData = (query) => {
        return network.api('get', '/hospital/baby-notes/initial-data' + query);
    }
    const storeBabyNote = (data) => {
        return network.api('post', '/hospital/baby-notes/store-baby-note', data);
    }
    const updateBabyNote = (data, id) => {
        return network.api('put', '/hospital/baby-notes/update-baby-note/' + id, data);
    }
    const fetchBabyNoteList = (query) => {
        return network.api('get', '/hospital/baby-notes/list' + query);
    }
    const fetchSingleBabyNote = (query, id) => {
        return network.api('get', '/hospital/baby-notes/show/' + id + query);
    }
    const removeBabyNote = (query, id) => {
        return network.api('delete', '/hospital/baby-notes/destroy/' + id + query);
    }
    
    //Investigation-head
    const fetchInvestigationHeads = (query) => {
        return network.api('get', '/hospital/investigation-heads/all' + query);
    }
    const fetchInvestigationHeadGetAll = (query) => {
        return network.api('get', '/hospital/investigation-heads/get-all' + query);
    }
    const fetchInvestigationHeadEndpointDropdown = (query) => {
        return network.api('get', '/dropdowns/investigation-head-endpoint' + query);
    }
    const fetchInvestigationHeadTypes = (query) => {
        return network.api('get', '/hospital/investigation-heads/get-types' + query);
    }
    const fetchDischargeStatus = (query) => {
        return network.api('get', '/hospital/investigation-heads/discharge-statuses' + query);
    }
    const fetchInvestigationHeadList = (query) => {
        return network.api('get', '/hospital/investigation-heads' + query);
    }
    const fetchInvestigationHeadGroup = (companyId, locationType) => {
        let url = `/hospital/investigation-heads/investigation-groups?company_id=${companyId}&is_flatten=1`;

        if (locationType) {
            url += `&location_type=${locationType}`;
        }

        return network.api('get', url);
    };
    const storeInvestigationHeadGroup = (data) => {
        return network.api('post', '/hospital/investigation-heads/investigation-groups', data);
    }
    const updateInvestigationHeadGroup = (data) => {
        return network.api('post', '/hospital/investigation-heads/investigation-groups/' + data.id, data);
    }
    const storeInvestigationHead = (data) => {
        return network.api('post', '/hospital/investigation-heads', data);
    }
    const updateInvestigationHead = (data) => {
        return network.api('post', '/hospital/investigation-heads/update-investigation', data);
    }

    //investigation-generals
    const fetchInvestigationGeneral = (query, billId) => {
        return network.api('get', '/hospital/investigation-generals/reports/' + billId + query);
    }
    const fetchInvestigationGeneralReports = (query, billId) => {
        return network.api('get', '/hospital/public/investigation-generals/reports/' + billId + query);
    }
    const fetchSaleGeneral = (query, id) => {
        return network.api('get', '/hospital/investigation-generals/show-sale-generals/' + id + query);
    }
    const fetchSaleGeneralDetails = (query, id) => {
        return network.api('get', '/hospital/public/investigation-generals/show-sale-generals/' + id + query);
    }
    const updateInvestigationGeneral = (data) => {
        return network.api('put', '/hospital/investigation-generals/update-investigation-general', data);
    }
    const saveInvestigationAttachment = (data, query) => {
        return network.api('post', '/hospital/investigation-generals/store-investigation-attachments' + query, data);
    }

    // service resource
    const fetchServiceResource = (id, query) => {
        return network.api('get', `/hospital/service-resources/${id}` + query);
    }

    // settlement handler
    const storeSettlement = (id, data) => {
        return network.api('post', `/hospital/ipd-statement/${id}/settlement`, data);
    }

    // settlement update andler
    const updateSettlement = (id, data) => {
        return network.api('put', `/hospital/ipd-statement/${id}/settlement`, data);
    }

    // receipt ledger generals
    const receiptLedgerGenerals = (id, query) => {
        return network.api('get', `/hospital/receipt-master/${id}/ledger-generals${query}`);
    }

    // Pharmacy
    const fetchReorderReport = (query) => {
        return network.api('get', '/hospital/pharmacy/reorder-reports' + query);
    }
    const fetchManufacturer = (query) => {
        return network.api('get', '/hospital/pharmacy/manufacturers' + query);
    }
    const fetchExpiredProductReport = (query) => {
        return network.api('get', '/hospital/pharmacy/expired-products-reports' + query);
    }
    const updateExpiredDate = (data, stockId) => {
        return network.api('put', `/hospital/pharmacy/update-expired-date/${stockId}`, data);
    }

    // Billing PDF Info
    const checkBillingInfo = (data) => {
        return network.api('post', `/hospital/public/billings/check-billing-info`, data);
    }

    // Group Template
    const fetchGroupTemplate = (query) => {
        return network.api('get', '/hospital/group-templates/list' + query);
    }
    const fetchTemplateList = (query) => {
        return network.api('get', '/hospital/group-templates/template-list' + query);
    }
    const fetchSingleTemplate = (query, id) => {
        return network.api('get', '/hospital/group-templates/single-template/' + id + query);
    }
    const storeGroupTemplate = (data) => {
        return network.api('post', '/hospital/group-templates/store-group-template', data);
    }
    const updateGroupTemplate = (data, id) => {
        return network.api('put', '/hospital/group-templates/update-group-template/' + id, data);
    }
    const deleteGroupTemplate = (query, id) => {
        return network.api('delete', '/hospital/group-templates/delete-group-template/' + id + query);
    }

    //incentive setup
    const fetchIncentiveSetupList = (query) => {
        return network.api('get', '/hospital/incentive-setup'+query);
    }

    const storeIncentiveSetup = (data, query) => {
        return network.api('post', '/hospital/incentive-setup'+query, data);
    }

    const fetchSingleIncentiveSetup = (incentiveId, query) => {
        return network.api('get', '/hospital/incentive-setup/' + incentiveId + query);
    }

    const updateIncentiveSetup = (data, incentiveId, query) => {
        return network.api('put', '/hospital/incentive-setup/'+ incentiveId + query, data);
    }

    const fetchUnpaidIncentivePayment = (query) => {
        return network.api('get', '/hospital/unpaid-incentive-payment'+query);
    }

    const storeIncentivePayment = (data, query) => {
        return network.api('post', '/hospital/incentive-payment'+query, data);
    }

    const fetchIncentivePayment = (query) => {
        return network.api('get', '/hospital/incentive-payment'+query);
    }

    const fetchIncentivePaymentSummary = (query) => {
        return network.api('get', '/hospital/incentive-summary'+query);
    }

    const fetchIncentivePaymentReport = (query) => {
        return network.api('get', '/hospital/incentive-payment-report'+query);
    }

    const fetchUnpaidBillCollection = (query) => {
        return network.api('get', '/hospital/unpaid-bill-collection'+query);
    }
    const fetchBillCollection = (query) => {
        return network.api('get', '/hospital/bill-collection'+query);
    }
    const fetchBillCollectionSummary = (query) => {
        return network.api('get', '/hospital/bill-collection-summary'+query);
    }
    const fetchBillCollectionReport = (query) => {
        return network.api('get', '/hospital/bill-collection-report'+query);
    }

    const updateReportStatus = (data) => {
        return network.api('put', '/hospital/investigation-generals/update-report-status', data);
    }

    const updateSampleStatus = (data) => {
        return network.api('put', '/hospital/investigation-generals/update-sample-status', data);
    }

    const updateInvestigationStatus = (data) => {
        return network.api('put', '/hospital/investigation-generals/update-status', data);
    }

    const getCellCounterMachineData = (query) => {
        return network.api('get', `/hospital/cell-counter-machine${query}`);
    }

    const fetchCellCounterMachine = (query, id) => {
        return network.api('get', '/hospital/cell-counter-machine/' + id + query);
    }

    const fetchInvestigationReportByBillNumber = (query) => {
        return network.api('get', `/hospital/investigation-report/by-bill${query}`);
    }

    return {
        dateOfBarthConvertToAge,
        chartLoading,
        calculateAge,
        capitalize,

        fetchGroup,
        storeGroup,
        updateGroup,

        fetchServiceResourceList,
        fetchServiceResources,
        fetchServiceResourceListView,
        fetchServiceResourceChild,
        storeServiceResource,
        updateServiceResource,

        fetchPatientsList,
        fetchPatientDetails,
        fetchPatientDetailsBySerial,

        fetchNoteMasterList,
        storeNote,
        updateNote,
        removeNote,
        fetchNoteTypes,
        notesByType,
        fetchPrescriptionNotes,
        fetchOpdPrescriptionReport,
        fetchGroupTemplateTabs,
        fetchSingleTemplate,
        noteNameByType,
        fetchNoteByKey,

        //IPD-Register
        fetchIPDRegistrationList,
        storeRegistration,
        updateRegistration,
        fetchServiceList,
        fetchAdmittedByUserList,
        fetchDepartList,
        fetchAdmissionNoteList,
        fetchSingleNote,
        fetchIpdRegStatus,
        fetchIpdRegNumbers,
        fetchIpdStatement,
        fetchIpdStatementDetails,
        fetchIpdStatementDetailsMulti,
        fetchTemplatePrescription,

        //Ot-Order
        fetchOtOrderTypes,
        storeOtOrder,
        updateOtOrder,
        fetchOtOrderList,
        fetchSingleOtOrder,
        removeOtOrder,

        //Ot-Order
        fetchInitialBabyNoteData,
        storeBabyNote,
        updateBabyNote,
        fetchBabyNoteList,
        fetchSingleBabyNote,
        removeBabyNote,

        //Prescription
        fetchSinglePrescription,
        storePrescription,
        updatePrescription,
        convertHeightToFeetAndInches,
        convertFeetAndInchesToCm,
        bmiCalculator,

        //Doctor-order
        fetchSingleDoctorOrder,
        fetchSingleDischargeOrder,

        //Investigation-head
        fetchInvestigationHeads,
        fetchInvestigationHeadEndpointDropdown,
        fetchInvestigationHeadGetAll,
        fetchInvestigationHeadTypes,
        fetchDischargeStatus,
        fetchInvestigationHeadList,
        fetchInvestigationHeadGroup,
        storeInvestigationHeadGroup,
        updateInvestigationHeadGroup,
        storeInvestigationHead,
        updateInvestigationHead,

        //Investigation-generals
        fetchInvestigationGeneral,
        fetchInvestigationGeneralReports,
        fetchSaleGeneral,
        fetchSaleGeneralDetails,
        updateInvestigationGeneral,
        saveInvestigationAttachment,
        updateReportStatus,
        updateSampleStatus,

        //Service Resource
        fetchServiceResource,

        storeSettlement,
        updateSettlement,
        receiptLedgerGenerals,

        // Pharmacy
        fetchReorderReport,
        fetchManufacturer,
        fetchExpiredProductReport,
        updateExpiredDate,

        // CheckBillingInfo
        checkBillingInfo,

        // Group Template
        storeGroupTemplate,
        updateGroupTemplate,
        deleteGroupTemplate,
        fetchGroupTemplate,
        fetchTemplateList,

        //incentive setup
        fetchIncentiveSetupList,
        storeIncentiveSetup,
        updateIncentiveSetup,
        fetchSingleIncentiveSetup,

        //incentive payment
        fetchUnpaidIncentivePayment,
        storeIncentivePayment,
        fetchIncentivePayment,
        fetchIncentivePaymentSummary,
        fetchIncentivePaymentReport,

        // bill collection
        fetchUnpaidBillCollection,
        fetchBillCollectionSummary,
        fetchBillCollection,
        fetchBillCollectionReport,
        updateInvestigationStatus,

        //cell counter
        getCellCounterMachineData,
        fetchCellCounterMachine,
        fetchInvestigationReportByBillNumber

    }
}
